import { css } from '@emotion/react';
import { IonImg, IonRouterLink, IonText } from '@ionic/react';
import React from 'react';
import clarityLogo from '../../assets/img/clarity.png';
import * as commonCss from '../../styles/common';

export const WidgetPoweredBy: React.FC = () => {
  const widgetPoweredByCss = {
    container: [
      css({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '1rem',
      }),
    ],
    text: [
      commonCss.italics,
      commonCss.smallText,
      css({
        fontFamily: 'Nunito',
      }),
    ],
    logo: [
      css({
        height: '1.8rem',
        marginLeft: '-0.1rem',
        marginRight: '-0.4rem',
      }),
    ],
  };
  return (
    <IonRouterLink href="https://clarity.io" target="_blank">
      <div css={widgetPoweredByCss.container}>
        <IonText color="dark" css={widgetPoweredByCss.text}>
          powered by
        </IonText>
        <IonImg css={widgetPoweredByCss.logo} src={clarityLogo} />
      </div>
    </IonRouterLink>
  );
};
